import { h } from '@stencil/core';
export const IconPlus = (props) => {
  const { pathProps, svgProps, width, height, align, margin } = props || {
    pathProps: { fill: 'currentColor' },
    svgProps: {},
    width: 12,
    height: 12,
    align: 'middle',
    margin: '0 5px',
  };
  return (h("svg", Object.assign({}, svgProps, { class: "icon-plus", style: {
      width: `${width}px`,
      height: `${height}px`,
      verticalAlign: `${align}`,
      margin: `${margin}`,
    }, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 50 50" }), h("path", Object.assign({}, pathProps, { d: "M47.747 22.747c1.18 0 2.253.965 2.253 2.253 0 1.288-1.073 2.253-2.253 2.253H27.253V47.64C27.253 48.927 26.288 50 25 50c-1.288 0-2.253-1.073-2.253-2.36V27.252H2.253C1.073 27.253 0 26.288 0 25c0-1.288 1.073-2.253 2.253-2.253h20.494V2.36C22.747 1.073 23.712 0 25 0c1.288 0 2.253 1.073 2.253 2.36v20.387h20.494z", fillRule: "evenodd" }))));
};
